function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { catchError, switchMap, mergeMap } from "rxjs/operators";
import { updateUserLocaleAction } from "../../../actions/userManagementActions";
import { UPDATE_USER_LOCALE_REQUEST } from "../../../actions/userManagementActions/actionTypes";
export var updateUserLocaleEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(UPDATE_USER_LOCALE_REQUEST), switchMap(function(action) {
        return from(api.userManagementServices.updateUserProfileInfo(_objectSpread({}, action.payload, {
            monsSelectLocale: action.payload.defaultLocale
        })).pipe(mergeMap(function(response) {
            return of(updateUserLocaleAction.success(response.user));
        }), catchError(function(err) {
            return of(updateUserLocaleAction.failure(err));
        })));
    }));
};
export default updateUserLocaleEpic;

//# sourceMappingURL=index.js.map